import gql from 'graphql-tag';

export const typeDefs = gql`
  type EstatusNotification {
    permiso: String!
    esCompatible: Boolean!
    existeSuscripcion: Boolean!
  }
  type Mutation {
    estatusNotificacionesCompatible(esCompatible: Boolean!): Boolean
    estatusNotificacionesPermiso(permiso: String!): String
    estatusNotificacionesSuscripcion(existe: Boolean!): Boolean
  }
`;
const estatusNotificacionesGql = gql`
  {
    estatusNotificaciones @client {
      permiso
      esCompatible
      existeSuscripcion
    }
  }
`;
export const resolvers = {
  Mutation: {
    estatusNotificacionesCompatible: (_, {esCompatible}, {cache}) => {
      const data = cache.readQuery({
        query: estatusNotificacionesGql,
      });
      const currentEstatus = JSON.parse(JSON.stringify(data));
      currentEstatus.estatusNotificaciones.esCompatible = esCompatible;
      cache.writeQuery({
        query: estatusNotificacionesGql,
        data: currentEstatus,
      });
      return currentEstatus.esCompatible;
    },
    estatusNotificacionesPermiso: (_, {permiso}, {cache}) => {
      const data = cache.readQuery({
        query: estatusNotificacionesGql,
      });
      const currentEstatus = JSON.parse(JSON.stringify(data));
      currentEstatus.estatusNotificaciones.permiso = permiso;
      cache.writeQuery({
        query: estatusNotificacionesGql,
        data: currentEstatus,
      });
      return currentEstatus.permiso;
    },
    estatusNotificacionesSuscripcion: (_, {existeSuscripcion}, {cache}) => {
      const data = cache.readQuery({
        query: estatusNotificacionesGql,
      });
      const currentEstatus = JSON.parse(JSON.stringify(data));
      currentEstatus.estatusNotificaciones.existeSuscripcion = existeSuscripcion;
      cache.writeQuery({
        query: estatusNotificacionesGql,
        data: currentEstatus,
      });
      return currentEstatus.existeSuscripcion;
    },
  },
};
